import { useCallback } from "react";
import {
  BsInfoCircle,
  BsCheckCircle,
  BsExclamationTriangle,
  BsXCircle,
} from "react-icons/bs";
import { generateIcon } from "utils";
import type { alertType } from "utils";

interface IAlertProps {
  title?: string;
  message: string;
  type: alertType;
  className?: string;
}

interface IAlertWrapperProps {
  type: string;
  children: React.ReactNode;
  className?: string;
}

export function Alert({
  title,
  message,
  type,
  className,
}: IAlertProps): JSX.Element {
  return (
    <AlertWrapper className={className} type={type}>
      <div>
        {title ? <h3 className="font-bold">{title}</h3> : ""}
        {message ? <div className="text-xxl">{message}</div> : ""}
      </div>
    </AlertWrapper>
  );
}

// WRAPPER

function AlertWrapper({
  type,
  children,
  className,
}: IAlertWrapperProps): JSX.Element {
  const getConfig = useCallback(() => {
    switch (type) {
      case "info":
        return { icon: BsInfoCircle, alertType: "alert-info alert-soft" };
      case "success":
        return { icon: BsCheckCircle, alertType: "alert-success" };
      case "warning":
        return { icon: BsExclamationTriangle, alertType: "alert-warning" };
      case "error":
        return {
          icon: BsXCircle,
          alertType: "text-error bg-error/20",
        };
      default:
        return { icon: BsInfoCircle, alertType: "" };
    }
  }, [type]);
  return (
    <div
      className={`alert ${getConfig().alertType} shadow-lg m-2 ${
        className || ""
      }`}
    >
      {generateIcon(getConfig().icon)}
      {children}
    </div>
  );
}
